import { useEffect, useState } from "react";
import { httpService } from "../services/httpService";

let cachedProfile = null;
let cachedAt = 0;
let inFlight = null;
const CACHE_MS = 60000;   // 1 minute

export const invalidateOnlineProfileCache = () => {
  cachedProfile = null;
  cachedAt = 0;
};

export const fetchOnlineProfileCached = async () => {
  if (cachedProfile && Date.now() - cachedAt < CACHE_MS) return cachedProfile;
  if (inFlight) return inFlight;

  inFlight = httpService
    .get("/vendors/getOnlineProfile", { skipToast: true })
    .then((res) => {
      cachedProfile = res?.data ?? null;
      cachedAt = Date.now();
      return cachedProfile;
    })
    .catch(() => {
      cachedAt = Date.now();
      return null;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
};

export const useOnlineProfile = () => {
  const [data, setData] = useState(cachedProfile);
  const [loading, setLoading] = useState(!cachedProfile);

  useEffect(() => {
    let cancelled = false;
    fetchOnlineProfileCached().then((p) => {
      if (!cancelled) {
        setData(p);
        setLoading(false);
      }
    });
    return () => { cancelled = true; };
  }, []);

  return { data, loading };
};